import { OhApi } from "@shared/libs/siayuda";

/**
 * ensure that real API error are thrown, allowing react query to consider it as an error
 * @param promisifiedRequest an OhApi promise
 * @returns the initial promise with an overloaded then
 * BEHOLD :some error types may not be currently handled
 */
export const rerouteApiError = <T>(promisifiedRequest: Promise<OhApi.ApiResponse<T>>) =>
  promisifiedRequest.then(resp => {
    if (OhApi.isSuccess(resp) || OhApi.isEmpty(resp)) {
      return { ...resp, value: resp.value ?? null } as OhApi.ApiSuccess<T>;
    } else if (OhApi.isFailure(resp)) {
      throw resp;
    } else {
      // should never happen given our custom fetch behavior (either success or failure)
      throw new Error("Unknown ApiResponse type : neither a Success nor a Failure");
    }
  });
